export default __webpack_public_path__ + "4bdc7da9e9b26cb1ddbcc66a27e7a467.svg";